module.exports = __webpack_public_path__ + "static/img/juxingfaPro.4806e71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/juxingfaPro.png
// module id = 5jMe
// module chunks = 1